import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { relationshipEdges, relationshipNodes } from "@/mocks/siteData";

const edgeIcon: Record<string, string> = {
  "祖孙传承": "ri-focus-2-line",
  "共同守护": "ri-shield-star-line",
  "村民羁绊": "ri-heart-3-line",
  "亦师亦友": "ri-team-line",
  "旧识之谜": "ri-question-line",
  "村民情谊": "ri-hand-heart-line",
};

export default function RelationshipSection() {
  const center = relationshipNodes[0];
  const others = relationshipNodes.slice(1);

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="人物关系"
          title="以店主为中心的关系网"
          desc="爷爷把店铺与秘密托付给子强，村庄里的人情则把一张看不见的网越拉越紧。"
        />
        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex h-full flex-col items-center justify-center rounded-lg border-2 border-primary-300 bg-primary-50 px-6 py-10 text-center">
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-store-2-line text-2xl" />
              </span>
              <h3 className="mt-4 font-heading text-2xl font-black text-primary-800">
                {center.name}
              </h3>
              <p className="mt-1 text-sm font-bold text-primary-700">{center.desc}</p>
              <p className="mt-4 text-xs leading-relaxed text-foreground-600">
                继承爷爷的杂货店，与墙上的「洞」打上交道的年轻店主。人物关系与店铺秘密都以他为圆心展开。
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-3">
            {others.map((n) => (
              <div
                key={n.name}
                className="flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 p-4"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-user-smile-line text-lg" />
                </span>
                <div className="min-w-0">
                  <p className="text-sm font-bold text-foreground-950">{n.name}</p>
                  <p className="text-xs text-foreground-600">{n.desc}</p>
                </div>
              </div>
            ))}
            <div className="sm:col-span-2">
              <ul className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                {relationshipEdges.map((e) => (
                  <li
                    key={`${e.from}-${e.to}`}
                    className="flex items-center gap-2 rounded-md bg-background-200/60 px-3 py-2 text-xs text-foreground-700"
                  >
                    <i className={`${edgeIcon[e.type] ?? "ri-link"} text-primary-700`} />
                    <span className="font-bold">{e.from}</span>
                    <i className="ri-arrow-right-line text-foreground-400" />
                    <span>{e.to}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-8 text-center">
          <Link
            to="/characters#relation"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-accent-300 bg-background-50 px-5 py-2.5 text-sm font-bold text-accent-700 transition-colors hover:bg-accent-50"
          >
            查看关系细节
            <i className="ri-arrow-down-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}